import {
  useEffect, useRef, useState, useMemo,
} from 'react';
import { useGetIdentity, useTranslate } from 'ra-core';
import { Asset, SecurityInventoryCategory } from '@x-guard/xgac-types/xgac';
import { useOutsideAlerter } from '../../../../../utils/useOutsideAlerter';
import { FilterRow } from '../../../components/deviceFilters';
import { InventoryItemFilter } from '../util';

export const InventoryItemFilters = (props: {
  filters: InventoryItemFilter;
  onChange: (filters: InventoryItemFilter) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  categories: SecurityInventoryCategory[];
  users: Asset[];
}) => {

  const translate = useTranslate();
  const filterRef = useRef(null);
  const [filterCategoriesOpen, setFilterCategoriesOpen] = useState<boolean>(false);
  const [innerFilters, setInnerFilters] = useState(props.filters);

  const { data: identity } = useGetIdentity();

  const currentUserId = identity?.id != null ? identity.id : undefined;
  const currentAssetId = useMemo(
    () => props.users.find((user) => user.user?._id != null && user.user._id === currentUserId)?._id,
    [props.users, currentUserId],
  );

  const filterAssigned = Boolean(currentAssetId && innerFilters.users.includes(currentAssetId));

  useOutsideAlerter(filterRef, () => props.setOpen(false));

  useEffect(() => {

    if (props.open) {

      setInnerFilters(props.filters);

    }

  }, [props.open, props.filters]);

  if (!props.open) {

    return null;

  }
  return (
    <div className="device-filter-div" ref={filterRef}>
      <div className="device-filter-div-inner">
        <ul onClick={() => {

          setFilterCategoriesOpen(false);

        }}>
          <FilterRow
            label={'resources.security-inventory-items.text.filter_category'}
            buttonLabelAll={'resources.security-inventory-items.text.all_categories'}
            buttonLabelSome={'resources.security-inventory-items.text.categories_chosen'}
            open={filterCategoriesOpen}
            setOpenFilter={() => setFilterCategoriesOpen(!filterCategoriesOpen)}
            onChange={(selectedOptions: string[] | number[]) => setInnerFilters(
              { ...innerFilters, categories: selectedOptions as string[] },
            )}
            options={props.categories.map((category) => ({ label: category.name, value: category._id }))}
            selected={innerFilters.categories}
          />
          <li
            className="device-filter-row"
            onClick={(e) => e.stopPropagation()}
          >
            <label style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <input
                type="checkbox"
                checked={filterAssigned}
                onChange={(e) => {

                  if (!currentAssetId) return;
                  setInnerFilters({
                    ...innerFilters,
                    users: e.target.checked ? [currentAssetId] : [],
                  });

                }}
              />
              <span style={{ marginLeft: 10 }}>{translate('resources.security-inventory-items.text.show_items_responsible')}</span>
            </label>
          </li>
        </ul>
        <div className="device-filter-buttons">
          <button onClick={() => {

            props.onChange({
              categories: [],
              users: [],
            });
            props.setOpen(false);

          }}>{translate('resources.buttons.text.remove_filters')}</button>
          <button onClick={() => {

            props.onChange(innerFilters);
            props.setOpen(false);

          }}>{translate('resources.buttons.text.save_filters')}</button>
        </div>
      </div>
    </div>
  );

};
